import IS_BROWSER from '../isBrowser/index.js';

var getCookie = function getCookie(name) {
  if (typeof document === 'undefined' || !IS_BROWSER) {
    return null;
  }
  var pair = document.cookie.match(new RegExp("".concat(name, "=([^;]+)")));
  return !pair ? null : pair[1];
};
var setCookie = function setCookie(key, value) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/';
  var maxAge = arguments.length > 3 ? arguments[3] : undefined;
  if (typeof document === 'undefined' || !IS_BROWSER) {
    return;
  }
  document.cookie = "".concat(key, "=").concat(value, "; ").concat(maxAge ? "Max-Age=".concat(maxAge, ";") : 'expires=Fri, 31 Dec 9999 23:59:59 GMT;', " path=").concat(path);
};
var deleteCookie = function deleteCookie(key) {
  var paths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['/'];
  if (typeof document === 'undefined' || !IS_BROWSER) {
    return;
  }
  paths.forEach(function (path) {
    document.cookie = "".concat(key, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=").concat(path, ";");
  });
};

export { deleteCookie, getCookie, setCookie };
//# sourceMappingURL=index.js.map
